import React, { useState, useEffect } from 'react';
import './unsubscribe-form-style.scss';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import envelop from '../../Assets/images/envelope.svg';
import { saveEmail } from '../../Services';
import { validateEmail, getLogo, getCompanyName } from '../../utils';

function UnSubscribeForm(props) {
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notifyEmail, setNotifyEmail] = useState('');

  useEffect(() => {
    const { location } = props;
    const { notify_email: notifyEmail } = location ? queryString.parse(location.search) : '';
    setNotifyEmail(notifyEmail);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { history } = props;
    setIsLoading(true);
    saveEmail(email, notifyEmail).then(() => {
      setIsLoading(false);
      setEmail('');
      history.push(`/confirm?notify_email=${notifyEmail}`);
    })
      .catch((err) => {
        console.log(JSON.stringify(err));
        toast.error('something went wrong');
        setIsLoading(false);
      });
  };
  const handleChangeEmail = (e) => {
    const email = e.target.value.trim().toLowerCase();
    const isEmailValid = validateEmail(email);
    setIsEmailValid(isEmailValid);
    setEmail(email);
  };
  return (
    <div className="unsubscribe__form__wrapper card">
      <img src={getLogo(notifyEmail)} className="ttn__logo display--block" alt="ttn-logo" />
      <img src={envelop} className="envelop__logo display--block" alt="envelop" />
      <p className="text">Would you like to unsubscribe from all {getCompanyName(notifyEmail)} emails ? </p>
      <form onSubmit={e => handleSubmit(e)}>
        <input type="text" value={email} name="email" onChange={handleChangeEmail} placeholder="Enter Your Email  " />
        <button type="submit" disabled={!isEmailValid} className="button display--block">{ isLoading ? 'Loading' : 'yes, unsubscribe me'}</button>
      </form>
    </div>
  );
}
UnSubscribeForm.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default UnSubscribeForm;
